<mainpanel
  [pageData]="pageData"
  Title="Product Report"
  [hideSearchBox]="true"
  [hideSearchDropdown]="true"
>
  <div content>
    <div class="container-fluid mt-5">
      <div class="table-responsive">
        <table class="table w-auto" matSort (matSortChange)="sortData($event)">
          <thead class="thead-light sticky-top-thead">
            <tr>
              <th>Subdomain</th>
              <th class="text-end" mat-sort-header="RecordsCount" arrowPosition="before">Product</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of (productList$ | async)"
              class="border-bottom"
            >
              <td>{{ item.SubDomain }}</td>
              <td class="text-end">{{ item.RecordsCount | number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</mainpanel>
